import { render, staticRenderFns } from "./SignatureCutPdfTool.vue?vue&type=template&id=c5efc770&scoped=true&"
import script from "./SignatureCutPdfTool.vue?vue&type=script&lang=js&"
export * from "./SignatureCutPdfTool.vue?vue&type=script&lang=js&"
import style0 from "./SignatureCutPdfTool.vue?vue&type=style&index=0&id=c5efc770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5efc770",
  null
  
)

export default component.exports